import apps from "@services/applications";

export default [
  {
    path: "/app/configuration-manager",
    name: "configuration-manager",
    meta: {
      module: "configuration-manager",
      application: apps.Modules.ConfigurationManager.Id,
      title: apps.Modules.ConfigurationManager.Name
    },
    component: () => import("@ConfigurationManager/views/ConfigurationManager.vue"),
    children: []
  }
];
